

import PageHeader from "app/shared/PageHeader";
import "./ReportView.scss";
import { Button, message, Modal, Radio, Tag } from "antd";
import { GlobalOutlined, MenuOutlined } from "@ant-design/icons";
import { useEffect, useRef, useState } from "react";
import TableViewManager from "app/shared/TableViewManager";
import { AgTableServer } from "app/shared/AgTable";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { apiGet, apiPost } from "app/services/apiServices";
import {
  API_ENDPOINT_FETCH_DB_TABLE_PREVIEW,
  API_ENDPOINT_FETCH_REPORT_TABLE_SCHEMA,
  API_ENDPOINT_FETCH_DB_TABLE_PREVIEW_PG
} from "app/scenes/FinkAnalytics/finkanalytics.constants";
import {
  getColumnDefinationFromTable,
  processZARowForColumnDefs,
} from "app/scenes/FinkAnalytics/fa.helper";
import Loader from "app/shared/Loader";
import TableViewManagerV2 from "app/shared/TableViewManagerV2";
import { useRecoilState } from "recoil";
import { activeTabAtom, userInfo } from "app/config/States/users";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { indexOf } from "lodash";
import { API_ENDPOINT_AG_TABLE_LIST_ALL_VIEW, API_ENDPOINT_AG_TABLE_LIST_ALL_VIEW_PUBLIC } from "app/shared/AgTable/AgTable.constants";
import OpenPrimaryNav from "app/shared/OpenPrimaryNav";
import { API_ENDPOINT_FETCH_PUBLIC_REPORT_INFO, API_ENDPOINT_FETCH_PUBLIC_REPORT_META } from "../../report.manager.constant";
import AppLoader from "app/shared/AppLoader";
import { tableSchema } from "app/config/States/agtable";
import { appMetaConfig } from "global.constants";
import { getSubdomain } from "app/utils/generic.helper";




export default function OpenReportView(props: any) {
  const [publicReportInfo, setPublicReportInfo] = useState<any>(null);
  const [selectedSheet, setSelectedSheet] = useState("DATA");
  const [isLoading, setLoading] = useState(true);
  const [colDefs, setColDefs] = useState<any[]>([]);
  const [selectedView, setSelectedView] = useState<any[]>([]);
  const [userDetails, setUserDetails] = useRecoilState<any>(userInfo);
  const [currentSheetIndex, setCurrentSheetIndex] = useState();
  const [showModal, setShowModal] = useState(false);
  const [publicReportMeta, setPublicReportMeta] = useState<any>(null);
  const [dbType, setDbType] = useState<string>("");
  const gridRef: any = useRef();
  const gridRefArray: any = useRef([]);




  const { reportId, publicToken } = useParams();
  //const { reportId } = useParams();
  const [searchParams] = useSearchParams();








  const fetchPublicReportInfo = async () => {
    setLoading(true)
    const response = await apiGet(API_ENDPOINT_FETCH_PUBLIC_REPORT_INFO + publicToken);
    if (response.status) {
      setPublicReportInfo(response.data);
      fetchTotalReportViews(response?.data?.workspace_id);
      fetchPublicReportMeta(response?.data);
      setDbType(response?.data?.meta?.dbType);
    }
    setLoading(false)
  };




  const [creatingRequest, setCreatingRequest] = useState(false);
  const reconPageRef: any = useRef();
  const [activeTab, setActiveTab] = useRecoilState(activeTabAtom);
  const [tableSchemaInfo] = useRecoilState<any>(tableSchema);
  const domain = getSubdomain();
  const [messageApi, contextHolder] = message.useMessage();
  const [showModelFor, setShowModalFor] = useState("");
  const [reportName, setReportName] = useState("");



  const handleRaiseReportRequest = async () => {
    setCreatingRequest(true);




    const backupPayload = {
      startRow: 0,
      endRow: 100,
      rowGroupCols: [],
      valueCols: [],
      pivotCols: [],
      pivotMode: false,
      groupKeys: [],
      filterModel: {},
      sortModel: [],
    };




    const payloadFromTable =
      (await reconPageRef.current?.getGridState()) || backupPayload;




    if (!reportSchema) {
      messageApi.error("Report schema not loaded yet");
      setCreatingRequest(false);
      return;
    }




    // Use moduleId and table_name directly from schema
    const moduleId = reportSchema.id;
    const tableName = reportSchema.internal_db_info?.table || reportSchema.name;
    const database = reportSchema.internal_db_info?.database;
    const dbType = reportSchema.internal_db_info?.dbType;
    const table = reportSchema.internal_db_info?.table;
    //const reportId = reportSchema.reportId;
    const workspaceId = reportSchema.workspace_id;




    const payload = {
      reportId,
      moduleId,
      database,
      dbType,
      table,
      workspaceId,
      table_name: tableName,
      name: publicReportInfo?.report_name,
      email: userDetails?.email,
      type: "AIRLINE",
      tablePayload: payloadFromTable,
    };






    try {
      const response = await apiPost(
        "https://stage-apiplatform.finkraftai.com/api/agtable/report/openRequest",
        payload
      );




      if (response.status) {
        messageApi.success({
          type: "success",
          content: response.data || "Report request submitted successfully!",
        });
      } else {
        messageApi.error("Failed to raise report request");
      }
    } catch (error) {
      messageApi.error("Something went wrong while raising report request");
    } finally {
      setCreatingRequest(false);
      setShowModal(false);
      setShowModalFor("");
      setReportName("");
    }
  };




  const endpoint: string =
    dbType === "mongo"
      ? API_ENDPOINT_FETCH_DB_TABLE_PREVIEW
        : API_ENDPOINT_FETCH_DB_TABLE_PREVIEW_PG;
     // : "http://192.168.0.159:7002/api/finalytics/tables/data/previewpg"






  const fetchPublicReportMeta = async (reportInfo: any) => {
    const response = await apiPost(API_ENDPOINT_FETCH_PUBLIC_REPORT_META + publicToken, { databaseName: reportInfo?.meta?.database, table: reportInfo?.meta?.table, dbType: reportInfo?.meta?.dbType });
    if (response.status) {
      setPublicReportMeta(response.data);
    }
  };




  useEffect(() => {
    fetchPublicReportInfo();
  }, []);

  useEffect(() => {
    if (selectedSheet && selectedSheet !== "DATA") {
      const index = currentSheetIndex || 0;

      // Find the view data for the selected sheet
      const viewData = selectedView.find(view => view._id === selectedSheet);

      // Add a small delay to ensure the grid is ready
      setTimeout(() => {

        // Check if we should use loadGridView or applyTestView
        const shouldUseLoadGridView = gridRefArray.current[index]?.loadGridView &&
          viewData?.state &&
          (Object.keys(viewData.state.filterState || {}).length > 0 ||
            (viewData.state.sortState || []).length > 0 ||
            (viewData.state.rowGroupColumns || []).length > 0);

        // Use loadGridView as the primary method - it handles all view state automatically
        if (shouldUseLoadGridView) {

          try {

            // Try different parameter combinations for loadGridView
            const result = gridRefArray.current[index].loadGridView(selectedSheet, "REPORT_MANAGER");

            // Check if loadGridView is a Promise and wait for it
            if (result && typeof result.then === 'function') {
              result.then((resolvedResult: any) => {
              }).catch((error: any) => {
              });
            }

            // Always apply additional state after loadGridView to ensure filters and sorting work
            setTimeout(() => {
              if (viewData?.state && gridRefArray.current[index]?.api) {


                if (Object.keys(viewData.state.filterState || {}).length === 0 && (viewData.state.sortState || []).length === 0) {
                }
                const gridApi = gridRefArray.current[index].api;

                // Apply filtering - always apply even if loadGridView was called
                if (viewData.state.filterState && Object.keys(viewData.state.filterState).length > 0) {
                  try {
                    gridApi.setFilterModel(viewData.state.filterState);

                    // Force refresh to show filtered results
                    gridApi.refreshServerSideStore({ purge: true });
                  } catch (filterError) {
                  }
                } else {
                }

                // Apply sorting - always apply even if loadGridView was called
                if (viewData.state.sortState && viewData.state.sortState.length > 0) {
                  try {
                    const sortModel = viewData.state.sortState.map((sort: any) => ({
                      colId: sort.colId,
                      sort: sort.sort
                    }));
                    gridApi.setSortModel(sortModel);
                    gridApi.redrawRows();
                  } catch (sortError) {
                  }
                } else {
                }

                // Apply column state if available
                if (viewData.state.columnState && viewData.state.columnState.length > 0) {
                  try {
                    gridApi.applyColumnState({
                      state: viewData.state.columnState,
                      applyOrder: true,
                      applySort: false,
                      applyFilter: false
                    });

                  } catch (columnError) {
                  }
                }
              } else {

              }
            }, 1500);

          } catch (error) {


            // Fallback to applyTestView if loadGridView fails
            if (viewData?.state && gridRefArray.current[index]?.applyTestView) {
              const viewConfig = {
                rowGroupCols: (viewData.state.rowGroupColumns || []).map((colId: string) => ({ field: colId })),
                sortModel: (viewData.state.sortState || []).map((sort: any) => ({
                  colId: sort.colId,
                  sort: sort.sort
                })),
                valueCols: viewData.state.valueCols || viewData.state.valueColumns || [],
                pivotCols: (viewData.state.pivotColumns || []).map((colId: string) => ({ field: colId })),
                filterModel: viewData.state.filterState || {},
                pivotMode: viewData.state.pivotMode || false,
                columnState: viewData.state.columnState || []
              };

              try {
                gridRefArray.current[index].applyTestView(viewConfig);
              } catch (fallbackError) {
              }
            }
          }
        } else {

          // Use applyTestView directly when loadGridView is not suitable
          if (viewData?.state && gridRefArray.current[index]?.applyTestView) {
            const viewConfig = {
              rowGroupCols: (viewData.state.rowGroupColumns || []).map((colId: string) => ({ field: colId })),
              sortModel: (viewData.state.sortState || []).map((sort: any) => ({
                colId: sort.colId,
                sort: sort.sort
              })),
              valueCols: viewData.state.valueCols || viewData.state.valueColumns || [],
              pivotCols: (viewData.state.pivotColumns || []).map((colId: string) => ({ field: colId })),
              filterModel: viewData.state.filterState || {},
              pivotMode: viewData.state.pivotMode || false,
              columnState: viewData.state.columnState || []
            };



            try {
              gridRefArray.current[index].applyTestView(viewConfig);


              // Apply additional state after applyTestView
              setTimeout(() => {
                if (viewData?.state && gridRefArray.current[index]?.api) {

                  const gridApi = gridRefArray.current[index].api;

                  // Apply filtering
                  if (viewData.state.filterState && Object.keys(viewData.state.filterState).length > 0) {

                    try {
                      gridApi.setFilterModel(viewData.state.filterState);

                      gridApi.refreshServerSideStore({ purge: true });
                    } catch (filterError) {

                    }
                  }

                  // Apply sorting
                  if (viewData.state.sortState && viewData.state.sortState.length > 0) {

                    try {
                      const sortModel = viewData.state.sortState.map((sort: any) => ({
                        colId: sort.colId,
                        sort: sort.sort
                      }));
                      gridApi.setSortModel(sortModel);
                      gridApi.redrawRows();

                    } catch (sortError) {

                    }
                  }
                }
              }, 1000);

            } catch (error) {
            }
          }
        }
      }, 100);
    }
  }, [selectedSheet, selectedView]);





  const fetchTotalReportViews = async (workspaceId: string) => {
    setLoading(true);




    const response = await apiPost(API_ENDPOINT_AG_TABLE_LIST_ALL_VIEW_PUBLIC, {
      moduleId: "REPORT_MANAGER",
      reportId: reportId,
      workspace_id: workspaceId,
    });
    if (response.data) {
      setSelectedView(response.data);
      fetchReportViewSchema(workspaceId);
    }
  };
  const [reportSchema, setReportSchema] = useState<any>(null);
  const fetchReportViewSchema = async (workspaceId: string) => {
    const response = await apiPost(
      API_ENDPOINT_FETCH_REPORT_TABLE_SCHEMA + reportId,
      {
        workspace_id: workspaceId,
      }
    );




    setColDefs(response.data.state?.columnDefs);
    setReportSchema(response.data);
    setLoading(false);
  };




  const handleExportAllToExcel = async () => {
    if (publicReportMeta?.totalItems > 10000) {
      message.info({
        content: (
          <span>
            Report has more than 10K items. Please download it by logging into the{" "}
            <a href="https://app.finkraft.ai" target="_blank" rel="noopener noreferrer">
              Finkraft Portal
            </a>.
          </span>
        ),
        duration: 8, // seconds before auto close
      });
      return;
    }
    const workbook = new ExcelJS.Workbook();




    let spreadsheets = [];




    let mainDataSheet =
      gridRef.current && gridRef.current.exportExcelDataRaw("Main Data");
    spreadsheets.push(mainDataSheet);




    for (let index = 0; index < gridRefArray.current.length; index++) {
      const singleGridRef = gridRefArray.current[index];




      if (singleGridRef && singleGridRef.exportExcelDataRaw) {
        let rawSheetData = singleGridRef.exportExcelDataRaw(
          selectedView[index]?.name || "Sheet"
        );




        spreadsheets.push(rawSheetData);
      } else {
      }
    }
    gridRef.current &&
      gridRef.current.exportMultipleSheetAsNewExcel(
        spreadsheets,
        "Finkraft_Report"
      );
  };




  const handleSelectView = (viewId: any) => {
    setSelectedView(viewId);
    setSelectedSheet(viewId[viewId.length - 1]);
  };




  const handleSaveView = (
    viewId: string,
    moduleId: string,
    viewName: string
  ) => {
    gridRef.current && gridRef.current.updateGridView(viewId, "REPORT_MANAGER");
    setSelectedView([...selectedView, { name: viewName, _id: viewId }]);
  };




  return (
    <div className="OpenReportView" style={{ height: "100vh" }}>
      {isLoading ? <div style={{ height: "100vh", width: '100%', display: "flex", alignItems: "center", justifyContent: "center" }}><AppLoader /></div> :
        <>
          <div className="MainSectionContainer">
            <div className="HeaderContainer">
              <PageHeader
                title={publicReportInfo?.report_name}
                noAuth
                rightActions={
                  <div style={{ display: "flex", alignItems: "center" }}>




                    <div style={{ marginRight: 12, marginLeft: 12 }}>
                      <Button
                        size="small"
                        onClick={() => message.info({
                          content: (
                            <span>
                              Downloading invoices is only available in the Finkraft Portal. Please login to the{" "}
                              <a href="https://portal.finkraft.ai" target="_blank" rel="noopener noreferrer">
                                Finkraft Portal
                              </a>.
                            </span>
                          ),
                          duration: 8, // seconds before auto close
                        })}
                        type="primary"
                      >
                        Download Invoice
                      </Button>
                    </div>




                    <Button
                      size="small"
                      type="primary"
                      //onClick={handleExportAllToExcel}
                      onClick={handleRaiseReportRequest}
                      style={{ marginRight: 24 }}
                    >
                      Download Report
                    </Button>
                  </div>
                }
              />
            </div>
            <Modal
              open={showModal}
              onCancel={() => setShowModal(false)}
              footer={false}
              centered
              title={null}
            >
              <div style={{ textAlign: "center", padding: 8 }}>
                <div
                  style={{
                    fontSize: 18,
                    fontWeight: 700,
                    marginBottom: 8,
                  }}
                >
                  Want to Download Invoices?
                </div>
                <div style={{ color: "#475569", marginBottom: 20 }}>
                  To download invoices, please visit the Finkraft portal.
                </div>
                <div style={{ display: "flex", justifyContent: "center", gap: 12 }}>
                  <Button




                    type="primary"
                    icon={<GlobalOutlined />}
                    size="small"
                    onClick={() => window.open("https://app.finkraft.ai", "_blank")}
                  >
                    Take me to Portal
                  </Button>
                </div>
              </div>
            </Modal>
            {isLoading ? (
              <div style={{ height: "100%" }}>
                <Loader />
              </div>
            ) : (
              <>
                <div className="MainContent">
                  <div
                    className={
                      "ViewContainer " +
                      (selectedSheet === "DATA" ? " " : " hiddenTable")
                    }
                  >
                    <AgTableServer
                      //@ts-ignore
                      columnDefs={colDefs}
                      // endpoint={API_ENDPOINT_FETCH_DB_TABLE_PREVIEW}
                      endpoint={endpoint}
                      // endpoint={"http://192.168.1.59:7001/api/recon/hotel"}
                      pdfDataKey="Invoice_link"
                      ref={gridRef}
                      serverPayload={{
                        database: publicReportInfo?.meta?.database,
                        dbType: publicReportInfo?.meta?.dbType,
                        table: publicReportInfo?.meta?.table,
                      }}
                      currentWorkspaceId={publicReportInfo?.workspace_id}
                      TableViewPayload={{
                        workspace_id: publicReportInfo?.workspace_id,
                        workspace_name: publicReportInfo?.workspace_name,
                        viewType: "REPORT_MANAGER",
                        reportId: publicReportInfo?.id,
                      }}
                      hideToolbar
                    />
                  </div>
                  {(selectedView || []).map((item: any, index: any) => {
                    return (
                      <div
                        className={
                          "ViewContainer " +
                          (selectedSheet === item?._id ? " " : " hiddenTable")
                        }
                        key={index}
                      >
                        <AgTableServer
                          key={index}
                          //@ts-ignore
                          columnDefs={colDefs}
                          endpoint={endpoint}
                          // endpoint={"http://192.168.1.59:7001/api/recon/hotel"}
                          pdfDataKey="Invoice_link"
                          ref={(el) => (gridRefArray.current[index] = el)}
                          serverPayload={{
                            database: publicReportInfo?.meta?.database,
                            dbType: publicReportInfo?.meta?.dbType,
                            table: publicReportInfo?.meta?.table,
                            defaultView: item?._id || "test",
                            selectedSheet
                          }}
                          moduleId="REPORT_MANAGER"
                          defaultView={item?._id}
                          currentWorkspaceId={publicReportInfo?.workspace_id}
                          TableViewPayload={{
                            workspace_id: publicReportInfo?.workspace_id,
                            workspace_name: publicReportInfo?.workspace_name,
                            viewType: "REPORT_MANAGER",
                            reportId: publicReportInfo?.id,
                          }}
                          hideToolbar
                        />
                      </div>
                    );
                  })}
                </div>




                <div className="SheetsContainer">
                  <Button
                    size="small"
                    type={selectedSheet === "DATA" ? "primary" : "default"}
                    icon={<MenuOutlined />}
                    onClick={() => setSelectedSheet("DATA")}
                  >
                    Data Sheet
                  </Button>




                  {selectedView.map((item: any, index: any) => {
                    return (
                      <Button
                        size="small"
                        style={{ marginLeft: 12 }}
                        icon={<MenuOutlined />}
                        onClick={() => {
                          setSelectedSheet(item?._id);
                          setCurrentSheetIndex(index);
                        }}
                        type={selectedSheet === item._id ? "primary" : "default"}
                      >
                        {item?.name + " Sheet"}
                      </Button>
                    );
                  })}
                  <div style={{ marginLeft: 12 }}>
                    <TableViewManagerV2
                      selectedSheet={selectedSheet}
                      moduleId={"REPORT_MANAGER"}
                      reportId={publicReportInfo?.id}
                      selectView={(viewId: string) => handleSelectView(viewId)}
                      updateView={handleSaveView}
                      updateViewNew={(viewId: string) =>
                        gridRefArray.current &&
                        gridRefArray.current?.[
                          currentSheetIndex || 0
                        ].updateGridView(selectedSheet, "REPORT_MANAGER")
                      }
                      workspace_id={userDetails?.currentWorkspace?.id}
                      workspace_name={userDetails?.currentWorkspace?.name}
                      viewMode
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </>}
    </div>
  );
}











